import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { BankAccount } from '../SiteClasses';
import API from '../API';

interface SearchAccountModalProps extends SearchCoreProps<BankAccount> {
	isWorkerAccount?: boolean;
}

var SearchAccountModal = (props: SearchAccountModalProps)=>{
	var isWorkerAccount = props.isWorkerAccount || false;
	
	return <SearchCoreModal
		title={isWorkerAccount ? 'Buscar cuenta bancaria de trabajador' : 'Buscar cuenta bancaria'}
		{...props}
		searchData={(query, page, page_size)=>{
			return API.searchAccounts(query, isWorkerAccount, page * page_size, page_size);
		}}
		pageSize={10}
		table={[
			{ name: 'Nombre', key: 'name_account', collapsing: true },
			{ name: 'Banco', key: 'bank', collapsing: true },
			{ name: 'RFC', key: 'rfc', collapsing: true },
			{ name: 'Correo', key: 'email_account', collapsing: true },
		]}
	/>
}

export default SearchAccountModal;